package one.healthium.insights.data.sources.network

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.http.GET
import de.jensklingenberg.ktorfit.http.Path
import io.ktor.client.HttpClient
import io.ktor.client.HttpClientConfig
import io.ktor.client.plugins.HttpResponseValidator
import io.ktor.client.plugins.ResponseException
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.client.plugins.logging.LogLevel
import io.ktor.client.plugins.logging.Logger
import io.ktor.client.plugins.logging.Logging
import io.ktor.http.HttpStatusCode
import io.ktor.serialization.kotlinx.json.json
import kotlinx.serialization.json.Json
import one.healthium.insights.data.dto.ContentScreenDto
import one.primehealth.app.BaseUrls

internal interface ContentApiClient {
    @GET("{locale}/view_models/{categoryId}.json")
    suspend fun getScreenModel(@Path("categoryId") categoryId: String, @Path("locale") locale: String): ContentScreenDto

    @GET("{locale}/insights/{insightId}.json")
    suspend fun getInsight(@Path("insightId") insightId: String, @Path("locale") locale: String): ContentScreenDto

    @GET("{locale}/mealplans/{id}.json")
    suspend fun getMealPlan(@Path("id") id: String, @Path("locale") locale: String): ContentScreenDto

    @GET("{locale}/view_models/workouts.json")
    suspend fun getWorkoutsScreen(@Path("locale") locale: String): ContentScreenDto

    @GET("{locale}/workouts/{id}.json")
    suspend fun getWorkout(@Path("id") id: String, @Path("locale") locale: String): ContentScreenDto

    @GET("{locale}/recipes/{id}.json")
    suspend fun getRecipe(@Path("id") id: String, @Path("locale") locale: String): ContentScreenDto

    companion object {
        fun factory(baseHttpClient: HttpClient, baseUrls: BaseUrls): ContentApiClient {
            val ktorfit = Ktorfit.Builder()
                .httpClient(baseHttpClient)
                .baseUrl(baseUrls.content)
                .build()
            return ktorfit.createContentApiClient()
        }

        // TODO move to common modules
        fun createBaseHttpClient(
            json: Json,
            block: HttpClientConfig<*>.() -> Unit = {},
        ) =
            HttpClient {
                expectSuccess = true
                HttpResponseValidator {
                    handleResponseExceptionWithRequest { cause, _ ->
                        val clientException = cause as? ResponseException ?: return@handleResponseExceptionWithRequest
                        val exceptionResponse = clientException.response
                        if (exceptionResponse.status == HttpStatusCode.NotFound) {
                            throw Exception("Content not found")
                        }
                        throw Exception("Something went wrong")
                    }
                }
                install(Logging) {
                    logger = object : Logger {
                        override fun log(message: String) {
                            co.touchlab.kermit.Logger.d(tag = "HTTP", messageString = message)
                        }
                    }
                    level = LogLevel.ALL
                }
                install(ContentNegotiation) {
                    json(json)
                }

                block()
            }

    }
}